// Combinations & Tabulator
export const APPLIED_ALIASES_IDS = [100, 101, 102]
export const APPLIED_FILTERS = [{ field: 'wt-part-WTPart:3338907929', value: '0004' }]
export const APPLIED_SORTERS = [{ column: 'com-ptc-windchill-option-model-Option-649660384', dir: 'asc' }]
export const CORRELATION_ID = '1631095822710'
export const PP = 'MjAyMDIx'
export const TABLE_HEADER = [
  { field: 'com.ptc.windchill.option.model.Option.1432007541', codeId: '0KH3', name: 'Achsanzahl', type: 'option' },
  { field: 'wt.part.WTPart:3338907929', codeId: '00TF', name: 'Generator Zusatz', type: 'component' }
]

// Tabulator modified data for request
export const ALIASES_AS_REQUEST_PARAMS = {
  'aliases[0][id]': APPLIED_ALIASES_IDS[0],
  'aliases[1][id]': APPLIED_ALIASES_IDS[1],
  'aliases[2][id]': APPLIED_ALIASES_IDS[2]
}
export const FILTERS_AS_REQUEST_PARAMS = {
  'filters[0][field]': APPLIED_FILTERS[0].field,
  'filters[0][type]': 'like',
  'filters[0][value]': APPLIED_FILTERS[0].value
}
export const SORTERS_AS_REQUEST_PARAMS = {
  'sorters[0][field]': APPLIED_SORTERS[0].column,
  'sorters[0][dir]': APPLIED_SORTERS[0].dir
}

export const ALIASES_LIST = [{
  optionId: 'com.ptc.windchill.option.model.Option.649660384',
  aliases: [
    { id: 81, name: 'Verteilergetriebe (  mit / ohne )', option: { name: 'OKHV' } },
    { id: 82, name: 'Zwei VA  ( 2 * VA  / 1 * VA  ) ', option: { name: '0KHV' } }
  ]
}]

// Selection details
export const COLLECTION_NAME = 'Collection name'
export const SELECTED_COMPONENTS = [{ id: '0000000017', id2: '00TF', name: 'Generator', componentVariants: [] }]
export const SELECTED_OPTIONS = [{ id: '649660384', id2: '0KHV', name: 'Radformel', choices: [] }]
